<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="年级名称">
              <j-dict-select-tag
                placeholder="请选择年级"
                v-model="queryParam.id"
                dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                style="width: 100%"
                allowClear
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">
                重置
              </a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('school_user_info')">
        导出
      </a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <a-button
        v-has="'virtualGrade:show'"
        type="primary"
        :loading="virtualLoading"
        @click="setVirtualGradeStatus"
      >
        {{ virtualGradeStatus == 0 ? '关闭' : '开启' }}虚拟年级
      </a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <student-grade-modal ref="modalForm" @ok="modalFormOk"></student-grade-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import StudentGradeModal from './modules/StudentGradeModal'
import { postAction } from '@/api/manage'

export default {
  name: 'StudentGradeList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    StudentGradeModal,
  },
  data() {
    return {
      description: 'student_grade管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '年级名称',
          align: 'center',
          dataIndex: 'gradeName',
        },
        {
          title: '年级主任名称',
          align: 'center',
          dataIndex: 'teacherName',
        },
        {
          title: '排序',
          align: 'center',
          dataIndex: 'sortOrder',
        },
        {
          title: '情绪阈值',
          align: 'center',
          dataIndex: 'threshold',
          customRender: (_, record) => {
            return record.threshold || '0'
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/aigoes/schoolGrade/list',
        delete: '/aigoes/schoolGrade/delete',
        deleteBatch: '/aigoes/schoolGrade/deleteBatch',
        exportXlsUrl: '/aigoes/schoolGrade/exportXls',
        importExcelUrl: 'aigoes/schoolGrade/importExcel',
      },
      dictOptions: {},
      disableMixinCreated: true,
      // 这边0是开启，1是关闭
      virtualGradeStatus: 0,
      virtualLoading: false,
    }
  },
  created() {
    this.loadData(0, (res) => {
      // isVirtual 0是关闭，1是开启
      this.virtualGradeStatus = res.result?.isVirtual == 1 ? 0 : 1
    })
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    async setVirtualGradeStatus() {
      const virtualGradeStatus = this.virtualGradeStatus == 0 ? 1 : 0
      this.virtualLoading = true
      const res = await postAction('/aigoes/schoolGrade/switchVirtual', {
        status: virtualGradeStatus,
      })
      this.virtualLoading = false
      if (res.success) {
        this.virtualGradeStatus = virtualGradeStatus
        this.$message.success(res.result || '操作成功')
        this.loadData()
      } else {
        this.$message.error(res.message || '操作失败')
      }
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
